import { Col, Container, Row, Spinner } from "react-bootstrap";
import CustomBreadcrumbs from "../components/navigation/breadcrumbs/CustomBreadcrumbs";
import DashboardButton from "../components/dashboard/DashboardButton";
import { FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import NewMonitoringModal from "../components/monitoring/NewMonitoringModal";
import { requestWithAuthorization } from "../network/apiRequests";


export default function MonitoringPage() {

    const [showCreateMonitoring, setShowCreateMonitoring] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [monitorings, setMonitorings] = useState<any[]>([])
    const [monitoringsContainer, setMonitoringsContainer] = useState(<></>)

    async function fetchMonitorings() {
        setIsLoading(true)
        try {
            const response = await requestWithAuthorization(
                process.env.REACT_APP_API_HOSTNAME + "/monitorings"
            );
            if (response.status === 200) {
                setMonitorings(response.data)
            } else {
                console.log("Error fetching monitorings")
            }
        } catch (error) {
            console.error(error)
        }
        finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        fetchMonitorings()
    }, [])

    function createMonitoring(name: string, description: string, sensors: string) {
        console.log("Creating monitoring with name:", name, "description:", description, "sensors:", sensors)
        sendCreateMonitoringRequest(name, description, sensors)
        setShowCreateMonitoring(false)
        console.log("API call to get all monitorings")
    }

    async function sendCreateMonitoringRequest(name: string, description: string, sensors: string) {
        setIsLoading(true)
        try {
            const response = await requestWithAuthorization(
                process.env.REACT_APP_API_HOSTNAME + "/monitorings",
                {},
                "put",
                {
                    name: name,
                    description: description,
                    sensors: sensors.split(",")
                }
            )
            if (response.status === 201) {
                console.log("Monitoring created successfully")
                fetchMonitorings()
            } else {
                console.log("Error creating monitoring")
            }
        } catch (error) {
            console.error(error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (isLoading) {
            setMonitoringsContainer(
            <Container fluid className="px-0">
                <Row className="d-flex">
                    <Col className="justify-content-center text-center">
                        <Spinner animation="border" role="status" />
                    </Col>
                </Row>
            </Container>);
        } else {
            if (monitorings.length === 0) {
                setMonitoringsContainer(
                    <Col className="justify-content-center text-center">
                        <h2>No monitorings found</h2>
                    </Col>
                );
            } else {
                setMonitoringsContainer(
                    <>
                        {monitorings.map((monitoring) => (
                            <Col key={monitoring.id} xs={12} sm={4} md={4} lg={3} xl={4} className="p-1">
                                <Link to={"/monitoring/" + monitoring.id} style={{ textDecoration: "None" }}>
                                    <Container className="session-tile p-4 d-flex">
                                        <Row>
                                            <Col>
                                                <Row className="pb-0">
                                                    <Col><span className="session-tile-title">{monitoring.name}</span></Col>
                                                </Row>
                                                <Row className="pb-2">
                                                    <Col><span className="session-tile-date">{monitoring.description}</span></Col>
                                                </Row>
                                                <Row className="pb-2">
                                                    <Col><span className="text-white">Sensors: {monitoring.sensors.join(", ")}</span></Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Link>
                            </Col>
                        ))}
                    </>
                );
            }
        }
    }, [isLoading, monitorings]);

    return (
        <>
        <NewMonitoringModal createMonitoring={createMonitoring} showCreateMonitoring={showCreateMonitoring} setShowCreateMonitoring={setShowCreateMonitoring} isLoading={isLoading} />
        <Container fluid className="p-4 background-color text-white">
            <Container fluid className="p-0">
                <Row>
                    <Col>
                        <h1>Monitoring Overview</h1>
                    </Col>
                    <Col className="d-flex justify-content-end">
                        <DashboardButton
                            icon={<FaPlus />}
                            text="Create New Monitoring"
                            onClick={() => setShowCreateMonitoring(true)}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>Create new Monitorings for different sensors & clusters of sensors or view the data</p>
                    </Col>
                </Row>
                <Container fluid className="p-0">
                    <Row className="px-1">
                        {monitoringsContainer}
                    </Row>
                </Container>
            </Container>
        </Container>
        </>
    )
}